import React from 'react';
import Hero from '../components/home/Hero';
import ServicesOverview from '../components/home/ServicesOverview';
import AboutOverview from '../components/home/AboutOverview';
import Testimonials from '../components/home/Testimonials';
import WhatsAppBooking from '../components/common/WhatsAppBooking';
import GoogleReviews from '../components/common/GoogleReviews';

const Home = () => {
  return (
    <>
      <Hero />
      <ServicesOverview />
      <AboutOverview />
      <GoogleReviews />
      <Testimonials />
      <WhatsAppBooking />
    </>
  );
};

export default Home;